var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubble1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 20.8334C28.7935 20.8334 29.1667 20.4602 29.1667 20.0001C29.1667 19.5399 28.7935 19.1667 28.3333 19.1667C27.8732 19.1667 27.5 19.5399 27.5 20.0001C27.5 20.4602 27.8732 20.8334 28.3333 20.8334Z",
    fill: "#2D2926",
    stroke: "#2D2926",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 20.8334C20.4602 20.8334 20.8334 20.4602 20.8334 20.0001C20.8334 19.5399 20.4602 19.1667 20.0001 19.1667C19.5399 19.1667 19.1667 19.5399 19.1667 20.0001C19.1667 20.4602 19.5399 20.8334 20.0001 20.8334Z",
    fill: "#2D2926",
    stroke: "#2D2926",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 20.8334C12.1268 20.8334 12.4999 20.4602 12.4999 20.0001C12.4999 19.5399 12.1268 19.1667 11.6666 19.1667C11.2064 19.1667 10.8333 19.5399 10.8333 20.0001C10.8333 20.4602 11.2064 20.8334 11.6666 20.8334Z",
    fill: "#2D2926",
    stroke: "#2D2926",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 36.6666C29.2046 36.6666 36.6666 29.2046 36.6666 19.9999C36.6666 10.7952 29.2046 3.33325 19.9999 3.33325C10.7952 3.33325 3.33325 10.7952 3.33325 19.9999C3.33325 23.0356 4.14487 25.8818 5.56295 28.3333L4.16659 35.8333L11.6666 34.4369C14.118 35.8549 16.9643 36.6666 19.9999 36.6666Z",
    stroke: "#2D2926",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble1);
export default __webpack_public_path__ + "static/media/chat-bubble 1.7f0497c87b94db2c1fdeae6e0b960ccf.svg";
export { ForwardRef as ReactComponent };